<div class="country-code-selector">
    <div class="tc-form-field size-md input-country-code-default" *ngIf="!selectedCountry.dialCode">
        <label class="label">
            {{'PROFILE.COUNTRY' | translate}}
        </label>
        <mat-form-field (click)="showOptionsCart(true)" appearance="outline" subscriptSizing="dynamic"
            class="input-field has-select-option">
            <input class="pointer" matInput>
            <span class="suffix-field is-icon" matSuffix>
                <i class="fa-solid fa-chevron-down"></i>
            </span>
        </mat-form-field>
    </div>
    <div class="tc-form-field size-md input-country-code" *ngIf="selectedCountry.dialCode">
        <label class="label">
            {{'PROFILE.COUNTRY' | translate}}
        </label>
        <mat-form-field (click)="showOptionsCart(true)" appearance="outline" subscriptSizing="dynamic"
            class="input-field has-select-option">
            <span [class]="'iti-flag iti-flag-selected ' + selectedCountry.flagClass" matPrefix></span>
            <input class="pointer" matInput>
            <span class="selected-dial-code">+{{selectedCountry.dialCode}}</span>
            <span class="suffix-field is-icon" matSuffix>
                <i class="fa-solid fa-chevron-down"></i>
            </span>
        </mat-form-field>
    </div>

    <div class="tc-form-field size-md phone-num">
        <label class="label">
            {{'PROFILE.MOBILE_NUMBER' | translate}}
        </label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field ltr-en-input">
            <input class="pointer" type="text" inputmode="tel" matInput [(ngModel)]="phoneNumber" tcOnlyTellNumber
                (paste)="onPhoneNumberChange()" (keyup)="onPhoneNumberChange()" [readonly]="isReadOnly"
                id="phoneNumberInput">
        </mat-form-field>
    </div>

    <div class="cart shadow" [ngClass]="{show: showOptions, hide: !showOptions }">
        <div class="tc-form-field size-md search-dropdown-field">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field">
                <input matInput (paste)="filter()" (keyup)="filter()" [(ngModel)]="searchValue" placeholder="Search">
            </mat-form-field>
        </div>
        <div class="options pointer">
            <div *ngFor="let item of filteredCountries" class="item" (click)="selectCountry(item)">
                <span [class]="'iti-flag ' + item.flagClass"></span>
                <span class="country-name" [matTooltip]="item.name">{{item.name}}</span>
                <span class="dial-code">+{{item.dialCode}}</span>
            </div>
        </div>
    </div>
</div>